﻿import React, {ReactNode, useEffect, useState} from 'react';


export interface GeocoderContextType {
    loading: boolean
    geocoder: any
}

const internalContext = React.createContext<GeocoderContextType>({
    loading: true,
    geocoder: {}
});

internalContext.displayName = 'GeocoderContext';

export const GeocoderProvider = ({children}: {children: ReactNode}) => {
    const [geocoderContext, setGeocoderContext] = useState({
        loading: false,
        geocoder: {}
    });

    useEffect(() => {
        const getGeocoderContext = async () => {
            setGeocoderContext({
                loading: true,
                geocoder: {}
            });
            const {Geocoder} = await google.maps.importLibrary('geocoding') as google.maps.GeocodingLibrary
            setGeocoderContext({
                loading: false,
                geocoder: new Geocoder()
            });
        }

        getGeocoderContext().catch(error => console.error(error));
    }, []);

    return <GeocoderContext.Provider value={geocoderContext}>
        {children}
    </GeocoderContext.Provider>;
}

export const GeocoderContext = internalContext;
